import { observable, computed, makeObservable } from 'mobx';
// @ts-expect-error unmanaged is only referenced inside a parameter decorator, which TS doesn't treat as a real reference under standard decorators
import { injectable, unmanaged } from 'inversify';
import { PageInfo } from '@shared/types/services';

@injectable()
export default class BaseStore<K extends InstanceType<any>, U extends InstanceType<any>> {
  static diToken = Symbol('base-store');
  protected service: U;
  protected _list: Array<K> = [];
  protected _pageInfo: PageInfo = {
    hasNextPage: false,
    hasPreviousPage: false,
    totalCount: 0,
  };
  loading: { [key: string]: boolean } = {
    list: false,
    item: false,
  };

  constructor(
    // @ts-expect-error parameter decorators require experimentalDecorators, which conflicts with mobx's standard decorators
    @(unmanaged() as ParameterDecorator) { service }: { service: U },
  ) {
    this.service = service;
    makeObservable<any>(this, {
      _list: observable,
      _pageInfo: observable,
      loading: observable,
      pageInfo: computed,
      list: computed,
    });
  }

  get pageInfo() {
    return this._pageInfo;
  }

  get list() {
    return this._list;
  }
}
